import { useContext } from 'react';
import { ReviewApprovalContext } from '../components/ReviewApprovalContext';

export function useReviewApprovalContext(ignoreError: boolean = false) {
    const context = useContext(ReviewApprovalContext);
    if (!context && !ignoreError) {
        throw new Error('useReviewApprovalContext must be used within a ReviewApprovalContext');
    }
    return context;
}
